import Tabs from 'components/Tabs';
import UserProfile from 'pages/settings/userProfile';
import GeneralSettings from 'pages/settings/generalSettings';
import SEO from 'components/SEO';

const SettingsPage = () => {
  const tabs = [
    {
      value: 'profile',
      label: 'User Profile',
      content: <UserProfile />,
    },
    {
      value: 'general',
      label: 'General Settings',
      content: <GeneralSettings />,
    },
  ];

  return (
    <>
      <SEO 
        title="Settings | Nucleus AI"
        description="Manage your account settings, user profile, and general preferences."
      />
      <Tabs defaultTab="profile" tabs={tabs} />
    </>
  );
};

export default SettingsPage;
